import React from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../store';
import BASE_URL from '../constants/Config';



export const slugify = (text: string) => {
  return text
    .toLowerCase()
    .replace(/ /g, '-') // Boşlukları tire ile değiştir
    .replace(/[^\w-]+/g, ''); // Alfanümerik olmayan karakterleri kaldır
};


function ServiceDetail() {
  const { title } = useParams();
  const service = useAppSelector((state) =>
    state.service.services.find((s) => slugify(s.title) === title)
  );

  const getPhotoUrl = (filePath: string) => {
    const fileName = filePath.split('/').pop();
    return `${BASE_URL}/api/OurServices/photo/${fileName}`;
  };

  if (!service) {
    return <div>Hizmet bulunamadı!</div>;
  }

  return (
    <div className="pt-24 pb-24">
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-lg overflow-hidden">
          {/* Fotoğrafın tamamını göstermek için object-contain kullandık */}
          <img
            src={getPhotoUrl(service.photoUrl)}
            alt={service.title}
            className="w-full h-64 object-contain mt-8 mb-8"
          />
          <div className="p-8">
            <h1 className="text-4xl font-bold mb-4 text-center">{service.title}</h1>
            <p className="text-lg text-gray-600 mt-6">{service.content}</p>
          </div>
        </div>
      </div>
    </div>
  );
  
  
  
}

export default ServiceDetail;
